export default {"src":"/_next/static/media/scholarship_rejected.d67e081f.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};